<template>
  <!-- wie bei stocks navi und breiter auf pc -->
  <div class="stock-shortcut-nav">
    <a
      v-for="(stockitem) in stocks"
      :key="stockitem.idstocks"
      :href="'#' + stockitem.stocks_name"
      class="stock-shortcut-link"
    >
      <v-btn
        class="stock-shortcut-btn"
        variant="flat"
        density="compact"
        size="small"
        :color="getCardcolor(stockitem)"
        :style="{ color: getShortcutTextColor(stockitem) }"
        @click="scrollTo(stockitem.stocks_name)"
        v-if="Number(users.iduser) !== 1 || Number(stockitem.user_iduser.iduser) === 1 || zeigeStocksAllerUser"
      >
        {{ stockitem.stocks_name.substring(0,3) }}
      </v-btn>
    </a>
  </div>

  <div v-for="stock in stocks" :key="stock.idstocks" class="chartbox">
    <div
      v-if="aktuellerUserId !== 1 || Number(stock.user_iduser.iduser) === 1"
      :id="stock.stocks_name"
    >
      <v-toolbar
        class="hidden-md-and-down"
        v-intersect="{
          options: { threshold: [0, 0.5, 1.0] }
        }"
        density="compact"
      >
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card
        class="mx-auto"
        :title="getChartTitle(stock.stocks_name, stock.stocks_Menge, stock.stock_Aktuellerkurs)"
        :color="getCardcolor(stock)"
        :subtitle="'symbol_' + stock.idstocks + stock.stocks_symbol_typ + ' 25% Verkaufskurs ' + Math.floor(stock.stock_25ProzentVerkauflimit) + ' €'"
        :prepend-avatar='"userdir/stocksymbols/symbol_" + stock.idstocks + "." + stock.stocks_symbol_typ'
      >
        <template v-slot:append>
          <v-avatar color="teal lighten-3" v-if="stock.stock_delta1_prozent >= 0">
            <v-icon icon="mdi-trending-up"></v-icon>
          </v-avatar>
          <v-avatar color="red lighten-3" v-if="stock.stock_delta1_prozent < 0">
            <v-icon icon="mdi-trending-down"></v-icon>
          </v-avatar>
        </template>

        <v-item-group multiple>
          <template v-if="stock.stock_delta1_prozent >= 0">
            <v-chip variant="flat" color="teal lighten-3" class="ma-2" append-icon="mdi-trending-up" size="x-small">
              Tag: {{ stock.stock_delta1_prozent }} %
            </v-chip>
          </template>
          <template v-else>
            <v-chip variant="flat" color="red lighten-3" class="ma-2" append-icon="mdi-trending-down" size="x-small">
              Tag: {{ stock.stock_delta1_prozent }} %
            </v-chip>
          </template>

          <template v-if="stock.stock_delta5_prozent >= 0">
            <v-chip variant="flat" color="teal lighten-3" class="ma-2" append-icon="mdi-trending-up" size="x-small">
              Woche: {{ stock.stock_delta5_prozent }} %
            </v-chip>
          </template>
          <template v-else>
            <v-chip variant="flat" color="red lighten-3" class="ma-2" append-icon="mdi-trending-down" size="x-small">
              Woche: {{ stock.stock_delta5_prozent }} %
            </v-chip>
          </template>

          <template v-if="stock.stock_delta20_prozent >= 0">
            <v-chip variant="flat" color="teal lighten-3" class="ma-2" append-icon="mdi-trending-up" size="x-small">
              Mon: {{ stock.stock_delta20_prozent }} %
            </v-chip>
          </template>
          <template v-else>
            <v-chip variant="flat" color="red lighten-3" class="ma-2" append-icon="mdi-trending-down" size="x-small">
              Monat: {{ stock.stock_delta20_prozent }} %
            </v-chip>
          </template>
        </v-item-group>
      </v-card>

      <v-card>
        <div style="max-width:2000px">
          <canvas :id="'stockchart_' + stock.idstocks.toString()"></canvas>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { Chart, registerables } from "chart.js"
import chartjsPluginAnnotation from "chartjs-plugin-annotation"
Chart.register(...registerables)
Chart.register(chartjsPluginAnnotation)

export default {
  name: 'ChartScreen',

  data() {
    return {
      prozent: false,
      counter: 0,
      aktuellerUserId: null,
      renderedCharts: new Set(),

      // ⚠️ falls du zeigeStocksAllerUser irgendwo brauchst:
      zeigeStocksAllerUser: false,

      lineChartData: {
        type: 'line',
        data: { labels: [], datasets: [] },
        options: {
          responsive: true,
          animation: false,
          spanGaps: true,      // ✅ wichtig, wenn mal ein Wert fehlt
        // parsing: false,   // ❌ erstmal AUS
          normalized: true, // ❌ erstmal AUS (kann später wieder an)
        plugins: {
          legend: { display: true, position: 'chartArea' },
          decimation: { enabled: true, algorithm: 'lttb', samples: 200 },
          annotation: { annotations: {} },
        },
        },
      },
    }
  },

  computed: {
    ...mapGetters({
      stocks: 'stateStocks',
      users: 'stateUser',
    }),
  },

  created() {
    const obj = this
    obj.$store.dispatch('getStocks').then(() => {
      obj.stocks.sort((a, b) => (a.stocks_name > b.stocks_name ? 1 : -1))
    })
  },

  mounted() {
    this.counter = 0
    this.aktuellerUserId = Number(this.$store.getters.stateUser.iduser)
    this.makeOptionsListFromStockList()
  },

  methods: {
    scrollTo(id) {
      const element = document.getElementById(id)
      if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },

    getChartTitle(stocks_name, stocks_Menge, stock_Aktuellerkurs) {
      let ChartTitle = stocks_name
      if (stocks_Menge > 0) {
        const Gesamtwert = Math.floor(stocks_Menge * stock_Aktuellerkurs)
        const formatter = new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: 'EUR',
          trailingZeroDisplay: 'stripIfInteger',
        })
        ChartTitle = `${stocks_name}         Gesamtwert: ${formatter.format(Gesamtwert)}`
      }
      return ChartTitle
    },

    getCardcolor(item) {
      const mengeRaw = (item?.stocks_Menge ?? '').toString().trim().replace(',', '.')
      const menge = parseFloat(mengeRaw)

      const typ = (item?.stocks_Typ ?? '').toString().trim().toLowerCase()
      const handelsplatz = (item?.stocks_Handelsplatz ?? '').toString().trim().toLowerCase()
      const name = (item?.stocks_name ?? '').toString().trim().toLowerCase()

      if (handelsplatz === 'virtuell' || name.includes('virtuell')) {
        return 'grey'
      }

      if (!Number.isNaN(menge) && menge === 0) {
        return 'grey'
      }

      if (typ === 'rohstoff') return 'amber-lighten-3'
      if (typ === 'etf') return 'light-green-lighten-3'
      if (typ === 'aktie') return 'blue-lighten-3'
      if (typ === 'fonds') return 'teal'
      if (typ === 'cash') return 'blue-grey'
      if (typ === 'krypto') return 'orange'

      return 'grey'
    },

    getShortcutTextColor(item) {
      const color = this.getCardcolor(item)

      if (['orange', 'green', 'grey', 'teal-lighten-3', 'blue-lighten-3', 'deep-purple-lighten-3'].includes(color)) {
        return '#111111'
      }

      return '#ffffff'
    },

    // Deep clone helper
    cloneDeep(x) {
      if (typeof structuredClone === 'function') return structuredClone(x)
      return JSON.parse(JSON.stringify(x))
    },

    // Concurrency limiter
    async runWithLimit(tasks, limit = 6) {
      const executing = []
      for (const task of tasks) {
        const p = Promise.resolve().then(task).finally(() => {
          const idx = executing.indexOf(p)
          if (idx >= 0) executing.splice(idx, 1)
        })
        executing.push(p)
        if (executing.length >= limit) {
          await Promise.race(executing)
        }
      }
      return Promise.allSettled(executing)
    },

    async makeOptionsListFromStockList() {
      const obj = this

      const visibleStocks = obj.stocks
        .filter(s => s.idstocks !== 1042)
        .filter(s =>
          obj.aktuellerUserId !== 1 || Number(s.user_iduser.iduser) === 1
        )

      const tasks = visibleStocks.map(stock => async () => {
        const ids = [stock.idstocks]

        // ✅ Vuex action muss return data machen!
        const histories = await obj.$store.dispatch('getStockhistories', ids)
        if (!Array.isArray(histories) || histories.length === 0) return
        console.log('###>>>typeof', typeof histories[0]?.['0_Virtuell_joe'])
        if (!histories || histories.length === 0) return

        // optional: Feld entfernen
        histories.forEach(x => { delete x["stocks_idstocks"] })

        let opts = obj.cloneDeep(obj.lineChartData)

        // ✅ FIX: robustes makeList (labels 1x, datum skip)
        opts = obj.makeList(histories, opts)

        // ✅ Vuex action muss return data machen!
        const signals = await obj.$store.dispatch('getSignale', ids)

        if (Math.min(window.screen.width, window.screen.height) > 768) {
          opts.options.plugins = opts.options.plugins || {}
          opts.options.plugins.annotation = opts.options.plugins.annotation || { annotations: {} }
          opts.options.plugins.annotation.annotations = signals
        }

        await obj.$nextTick()
        obj.drawChart2(opts, stock.idstocks)
      })
      const limit = window.innerWidth > 768 ? 8 : 4
      await obj.runWithLimit(tasks, limit)
    },

    drawChart2(lineChartData, idstocks) {
      const canvasID = 'stockchart_' + idstocks.toString()

      const chartStatus = Chart.getChart(canvasID)
      if (chartStatus) chartStatus.destroy()

      const ctx = document.getElementById(canvasID)
      if (!ctx) return

      new Chart(ctx, {
        type: lineChartData.type,
        data: lineChartData.data,
        options: lineChartData.options,
      })
    },

    // ✅ FIXED makeList: labels 1x, datum nicht als dataset
    makeList(filteredListGlobal, stockhistoriesOptions) {
      // 1) Labels nur einmal
      stockhistoriesOptions.data.labels = filteredListGlobal.map(r => r.datum)
      stockhistoriesOptions.data.datasets = []

      const keys = Object.keys(filteredListGlobal[0])

      for (const key of keys) {
        // datum ist X-Achse, NICHT zeichnen
        if (key === 'datum') continue
        if (key === 'id' || key === 'stocks_idstocks') continue


        // trend separat (falls vorhanden)
        if (key === 'trend') {
          const dsTrend = {
            label: key,
            data: filteredListGlobal.map(r => r[key]),
            fill: false,
            pointRadius: 0,
            borderDash: [10, 10],
            borderColor: 'Yellow',
            borderWidth: 2,
          }
          stockhistoriesOptions.data.datasets.push(dsTrend)
          continue
        }

        // normale Preis/MA Keys (z.B. 0_Virtuell_joe, MA20/50/200)
        const ds = {
          label: key,
          data: filteredListGlobal.map(r => {
            if (this.prozent === true) {
              return (r[key] / filteredListGlobal[0][key]) * 100
            }
            return r[key]
          }),
          fill: false,
          pointRadius: 0,
          borderWidth: 2,
          //borderColor: '#e4f2f2',
        }
         if (!key.startsWith('MA')) {
          ds.borderColor = '#faf7f7'  // weisse PreisKurve
        }

        if (key === 'MA20') {
          ds.borderColor = '#a0b58b'
          ds.borderDash = [10, 10]
          ds.borderWidth = 1
        } else if (key === 'MA50') {
          ds.borderColor = '#4366d1'
          ds.borderDash = [10, 10]
          ds.borderWidth = 2
        } else if (key === 'MA200') {
          ds.borderColor = '#d1437c'
          ds.borderDash = [10, 10]
          ds.borderWidth = 2
        }

        stockhistoriesOptions.data.datasets.push(ds)
      }

      // Dummy legend entries (wie bei dir)
      const green = '#748f6a'
      const orange = '#9e6b3c'

      stockhistoriesOptions.data.datasets.push({
        label: '25% VERKAUF Signal',
        data: [],
        type: 'line',
        borderColor: orange,
        borderWidth: 2,
        borderDash: [5, 2],
      })

      stockhistoriesOptions.data.datasets.push({
        label: '25% KAUF Signal',
        data: [],
        type: 'line',
        borderColor: green,
        borderWidth: 2,
        borderDash: [5, 2],
      })

      stockhistoriesOptions.data.datasets.push({
        label: 'MA20 > MA50 VERKAUF Signal',
        data: [],
        type: 'line',
        borderColor: orange,
        borderWidth: 1,
      })

      stockhistoriesOptions.data.datasets.push({
        label: 'MA200xMA50 KAUF Signal',
        data: [],
        type: 'line',
        borderColor: green,
        borderWidth: 1,
      })

      // Scales (mobile/pc wie bei dir)
      if (Math.min(window.screen.width, window.screen.height) < 768) {
        stockhistoriesOptions.options.scales = {
          y: { position: 'right', id: 'y-axis-0' },
          x: {
            ticks: { display: false },
            grid: { drawBorder: false, display: false },
          },
        }
      } else {
        stockhistoriesOptions.options.scales = {
          y: { position: 'right', id: 'y-axis-0' },
        }
      }

      // ✅ plugins NICHT überschreiben -> nur mergen
      stockhistoriesOptions.options.plugins = {
        ...(stockhistoriesOptions.options.plugins || {}),
        legend: { display: true, position: 'chartArea' },
        annotation: stockhistoriesOptions.options.plugins?.annotation || { annotations: {} },
      }

      return stockhistoriesOptions
    },
  },
}
</script>

<style>
.stock-shortcut-nav {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  padding: 8px 12px 14px;
  overflow: visible;
  background: #212121;
}

.stock-shortcut-link {
  display: inline-flex;
  text-decoration: none;
  line-height: 1;
}

.stock-shortcut-btn {
  min-width: 72px;
  margin: 0;
}

.chartbox {
  min-width: 100px;
  scroll-margin-top: 96px;
}
</style>
